import type { KeyboardEvent, RefObject } from 'react';
import type { LiksDropdownOption } from './LiksDropdown.types';
import type { LiksDropdownTypeaheadState } from './liksDropdownKeyboard';
import {
  handleDropdownListNavigationKeyDown,
  handleDropdownTypeaheadKey,
} from './liksDropdownKeyboard';

export function handleDropdownTriggerKeyDown(options: {
  event: KeyboardEvent<HTMLButtonElement>;
  disabled: boolean;
  optionsLength: number;
  filterable: boolean;
  isOpen: boolean;
  activeIndex: number;
  selectedIndex: number;
  visibleOptions: LiksDropdownOption[];
  typeaheadRef: RefObject<LiksDropdownTypeaheadState>;
  open: () => void;
  close: () => void;
  moveActiveIndex: (nextIndex: number) => void;
  selectIndex: (index: number) => void;
  setActiveIndex: (index: number) => void;
  focusTrigger: () => void;
}): void {
  const {
    event,
    disabled,
    optionsLength,
    filterable,
    isOpen,
    activeIndex,
    selectedIndex,
    visibleOptions,
    typeaheadRef,
    open,
    close,
    moveActiveIndex,
    selectIndex,
    setActiveIndex,
    focusTrigger,
  } = options;

  if (disabled || optionsLength === 0) {
    return;
  }
  if (
    !event.ctrlKey &&
    !event.metaKey &&
    !event.altKey &&
    handleDropdownTypeaheadKey({
      key: event.key,
      filterable,
      isOpen,
      activeIndex,
      selectedIndex,
      optionsLength,
      visibleOptions,
      typeaheadRef,
      setActiveIndex,
      selectIndex,
    })
  ) {
    event.preventDefault();
    return;
  }
  if (
    handleDropdownListNavigationKeyDown({
      event,
      isOpen,
      activeIndex,
      visibleOptionsLength: visibleOptions.length,
      open,
      close,
      moveActiveIndex,
      selectIndex,
      focusTrigger,
    })
  ) {
    return;
  }
  switch (event.key) {
    case 'Enter':
    case ' ': {
      event.preventDefault();
      if (!isOpen) {
        open();
        break;
      }
      selectIndex(activeIndex);
      break;
    }
    case 'Tab': {
      if (isOpen) {
        close();
      }
      break;
    }
    default:
      break;
  }
}

export function handleDropdownFilterKeyDown(options: {
  event: KeyboardEvent<HTMLInputElement>;
  isOpen: boolean;
  activeIndex: number;
  visibleOptionsLength: number;
  open: () => void;
  close: () => void;
  moveActiveIndex: (nextIndex: number) => void;
  selectIndex: (index: number) => void;
  focusTrigger: () => void;
}): void {
  const {
    event,
    isOpen,
    activeIndex,
    visibleOptionsLength,
    open,
    close,
    moveActiveIndex,
    selectIndex,
    focusTrigger,
  } = options;

  if (
    handleDropdownListNavigationKeyDown({
      event,
      isOpen,
      activeIndex,
      visibleOptionsLength,
      open,
      close,
      moveActiveIndex,
      selectIndex,
      focusTrigger,
    })
  ) {
    return;
  }
  if (event.key === 'Tab' && isOpen) {
    close();
  }
}
